import React from "react";
import "./CyberSecuritySection.css";
import { FaShieldAlt, FaLock, FaLaptopHouse, FaBug, FaEnvelopeOpenText, FaUserSecret, FaComments, FaVirus, FaUserFriends, FaMobileAlt, FaDatabase, FaCloud, FaFlag, FaBitcoin } from "react-icons/fa";

const CyberSecuritySection = () => {
  const topics = [
  { label: "Security Awareness Essentials", icon: <FaShieldAlt color="#2F855A" /> },
  { label: "Password Management", icon: <FaLock color="#D69E2E" /> },
  { label: "Working Remotely", icon: <FaLaptopHouse color="#4A5568" /> },
  { label: "Phishing & Ransomware", icon: <FaBug color="#E53E3E" /> },
  { label: "Business Email Compromise", icon: <FaEnvelopeOpenText color="#3182CE" /> },
  { label: "Social Engineering", icon: <FaUserSecret color="#805AD5" /> },
  { label: "Email & Messaging Security", icon: <FaComments color="#38B2AC" /> },
  { label: "Malware Best Practices", icon: <FaVirus color="#DD6B20" /> },
  { label: "Insider Threats", icon: <FaUserFriends color="#ED8936" /> },
  { label: "Preventing Malware on Mobile Devices", icon: <FaMobileAlt color="#3182CE" /> },
  { label: "Privacy, Data Protection, GDPR", icon: <FaDatabase color="#2B6CB0" /> },
  { label: "Cloud Security", icon: <FaCloud color="#00B5D8" /> },
  { label: "Incident Reporting", icon: <FaFlag color="#E53E3E" /> },
  { label: "Cryptojacking", icon: <FaBitcoin color="#F6AD55" /> }
];
  return (
    <div className="cyber-section">

      {/* 🛡️ Hero Section */}
      <div className="cyber-hero-banner">
        {/* <img src="" alt="Cybersecurity Banner" className="hero-bg-img" /> */}
        <div className="hero-overlay">
          <div className="hero-text">
            <h1>Managed Security Awareness Training Services</h1>
          </div>
        </div>
      </div>

      {/* ✅ Feature + Stat Section */}
      <div className="cyber-feature">
        <div className="cyber-feature-left">
          <img src="/human-error1.jpg" alt="Awareness Illustration" />
          <p className="stat-text">Over <strong>70% of Data Breaches</strong> <br />are Caused by Human Error</p>
        </div>
        <div className="cyber-feature-right">
          <h2>Change User Behavior & Reduce Risk</h2>
          <p>
            Our Managed Security Awareness Training is designed to change organizational culture and reduce human-related risk by educating employees.
          </p>
          <p>
            It includes bite-sized video lessons and testing to ensure retention. It’s a comprehensive program that combines learning, repetition, and reporting to empower smarter decision-making.
          </p>
        </div>
      </div>
{/* 📚 Topics Grid Section */}
<div className="cyber-topics-grid-section">
  <h3 className="topics-heading">Broad Topic Coverage</h3>
  <div className="topics-grid">
    {topics.map((item, index) => (
      <div key={index} className="topic-item">
        <span className="check-icon">{item.icon}</span>
        {item.label}
      </div>
    ))}
  </div>
</div>

{/* 🧠 Learning & Compliance Text Blocks */}
<section className="cyber-learning-compliance">
  <div className="learning-block">
    <h3>Spaced Learning & Repetition</h3>
    <p>
      Authored by security experts and designed by adult learning specialists, our engaging modular content relies on scientifically proven spaced learning & repetition methods to ensure adoption & long-term knowledge retention.
      <br /><br />
      Instead of digging through a crowded catalog of frivolous content, select the topics most relevant to your organization. Topics are delivered as a series of 1–3-minute nano learning modules delivered to all employees every 3 weeks all-year round. Eliminate training burnout and fatigue.
    </p>
  </div>

  <div className="learning-block">
    <h3>Adhere to PCI DSS Compliance Mandates</h3>
    <p>
      Requirement 12.6 of PCI DSS mandates that all organizations implement a formal security training program for employees. These mandates apply to organizations of all sizes. In addition, industry frameworks like ISO 27001 mandate the implementation of a formal Security Awareness Training as part of an overall risk management program.
      <br /><br />
      Comply with all your compliance mandates in an effective way with our Managed Security Awareness Training program.
    </p>
  </div>
</section>



      {/* 💼 Redesigned Benefits Section */}
<section className="cyber-benefits-redesign">
  <div className="benefits-content">
    <div className="benefits-list">
      <h3>Key Business Benefits</h3>
      <div className="benefit-items">
        {[
          "Lower cybersecurity risk",
          "Meet compliance requirements",
          "Reduce human-caused breaches",
          "Engage users with relatable content",
          "Automated testing & tracking"
        ].map((item, index) => (
          <div key={index} className="benefit-card">
            <span className="benefit-icon">✔</span>
            <p>{item}</p>
          </div>
        ))}
      </div>
    </div>

    {/* <div className="benefits-image">
      <img src="/assets/breach-cost.png" alt="Breach Cost" />
      <div className="breach-highlight">
        💸 Average Cost of a Data Breach: <strong>$4.35 Million</strong>
      </div>
    </div> */}
  </div>
</section>


      {/* 📣 CTA */}
   <div className="bottom-cta">
  <div className="cta-container">
    <h3>
      Looking for domain expertise in Payment Solutions?
    </h3>
    <p>
      Accelerate Time-to-Market with our Certification Service.
    </p>
    <button>
      Schedule Demo Now →
    </button>
  </div>
</div>
    </div>
  );
};

export default CyberSecuritySection;
